.productCardImage {
  aspect-ratio: 1;
  transition: box-shadow 0.35s ease, border-color 0.35s ease;
}

.productCardImage img {
  cursor: pointer;
  border-radius: var(--card-border-radius);
  transition: transform 0.35s ease;
}

.productCardImage div {
  cursor: pointer;
}

.productLink {
  text-decoration: none;
}

.imageLink {
  width: 100%;
}

/* Mid-grid placement card variant */
.productCardPlacement {
  background-color: var(--colors-grays-white);
  border-radius: var(--card-border-radius);
}

.productCardPlacement .productCardImage {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .productCardImage img {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .priceAndAddToCartContainer {
  padding: 0 8px 8px;
}

.cardBorder {
  border: 1px solid var(--colors-grays-light);
  border-radius: var(--border-radius-lg);
  padding: 12px;
  transition: box-shadow 0.35s ease, border-color 0.35s ease;
}

.cardBorder .productCardImage {
  border: 1px solid var(--colors-grays-ultralight);
}

.cardBorder.productCardPlacement .productCardImage,
.cardBorder.productCardPlacement .productCardImage img {
  border-radius: var(--card-border-radius);
}

@media (--reefer-media-tablet-min) {
  .cardBorder_small {
    padding: 12px;
  }

  .cardBorder_medium {
    padding: 16px;
  }

  .cardBorder_large {
    padding: 20px;
  }
}

/* Hover/focus effects */
.hover_image_border:not(.cardBorder) .productCardImage {
  border: 2px solid transparent; /* Prevents layout shift on hover/focus */
}

/* shadow */
.cardBorder.hover_shadow:hover,
.cardBorder.hover_shadow:focus-within,
.hover_shadow:not(.cardBorder):hover .productCardImage,
.hover_shadow:not(.cardBorder):focus-within .productCardImage {
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 12%);
}

/* shadow_color */
.cardBorder.hover_shadow_color:hover,
.cardBorder.hover_shadow_color:focus-within,
.hover_shadow_color:not(.cardBorder):hover .productCardImage,
.hover_shadow_color:not(.cardBorder):focus-within .productCardImage {
  box-shadow: 0 2px 16px 0 color-mix(in srgb, var(--colors-primary-main) 20%, transparent);
}

/* image_border */
.cardBorder.hover_image_border:hover,
.cardBorder.hover_image_border:focus-within,
.hover_image_border:not(.cardBorder):hover .productCardImage,
.hover_image_border:not(.cardBorder):focus-within .productCardImage {
  border-color: var(--colors-primary-main);
}

/* image_zoom */
.hover_image_zoom:hover .productCardImage img,
.hover_image_zoom:focus-within .productCardImage img {
  transform: scale(1.11);
}
